import React, { useState } from 'react'
import { MdSearch } from 'react-icons/md'
import clsx from 'clsx'

const Search = ({ query, results, resultComponent: ResultComponent, onKeyUp, className }) => {
	const [$escaped, set$escaped] = useState(false)

	function onKeyUpDefault(e) {
		set$escaped(e.key === 'Escape')
		onKeyUp(e)
	}

	return (
		<div className={clsx('relative', className)}>
			<label className="relative">
				<MdSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-2xl pointer-events-none" />

				<input type="search"
					className="input w-full py-[0.75em] pl-[2.5em] pr-[1.5em]"
					onKeyUp={onKeyUpDefault}
					placeholder="Search articles"
				/>
			</label>

			{(!!query && !$escaped) && (
				<div className="absolute left-0 right-0 top-full mt-1 px-2 bg-white rounded shadow-xl max-h-[300px] overflow-y-auto">
					{!!results?.length && (
						<ul className="grid gap-2 my-2">
							{results?.map((result, key) => (
								<li key={key}>
									<ResultComponent {...result} query={query} />
								</li>
							))}
						</ul>
					)}

					<p className={clsx(
						'sticky bottom-0 bg-white text-center text-grounding-navy/50 p-2 text-sm',
						!!results?.length && 'border-t border-grounding-navy/10 pt-2'
					)}>
						{results?.length || 'No'} results for "{query}"
					</p>
				</div>
			)}
		</div>
	)
}

export default Search
